module.exports = __webpack_public_path__ + "assets/253df6b156a9b8d795e67adb7a7ee75d.mp3";